// extracted by mini-css-extract-plugin
module.exports = {"title":"SponsorSlider_title__P3FZu","sponsor-slider":"SponsorSlider_sponsor-slider__rNybB","fix-auto-slides-per-view":"SponsorSlider_fix-auto-slides-per-view__5UiLw"};